const BenefitItem = ({ text }) => (
  <div className="w-[231px] flex items-center">
    <div className="w-6 h-6 p-1 rounded-3xl flex justify-center items-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path
          d="M11.6666 3.5L5.24998 9.91667L2.33331 7"
          stroke="#006EB7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
    <div className="grow about-us-text-ul">{text}</div>
  </div>
);

export default BenefitItem;
